import React, {useEffect, useState} from 'react';
import {Button, Form, Modal, Select} from "semantic-ui-react";
import {useForm} from "react-hook-form";
import {fetchCourseCategories, postCourses} from "../../../../redux/actions";

const token = sessionStorage.getItem('Token')

export const CourseForm = ({show, onCancel, onSuccess}) => {

    const [categories, setCategories] = useState([]);
    const {register, handleSubmit, setValue, formState} = useForm({
        defaultValues: {
            course_category_id: '',
            name: '',
            description: '',
            product: 1,
        }
    });

    React.useEffect(() => {
        register('course_category_id');
    }, [register])


    useEffect(() => {
        async function getData() {
            try {
                const res = await fetchCourseCategories({active: 1, product: 1});
                const options = res.data
                    .map(function (row) {
                        return {
                            key: row.id,
                            text: row.name,
                            value: row.id,
                        };
                    });
                setCategories(options);
            } catch (e) {
                console.log(e);
            }
        }

        // noinspection JSIgnoredPromiseFromCall
        getData();
    }, [token]);

    const onSubmit = async data => {

        try {
            const res = await postCourses(data);

            onSuccess(res.data);
        } catch (e) {
            alert('error')
        }
    };

    return (
        <Modal open={show} size={'tiny'}>
            <Modal.Header>Criar curso</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <Form id={'form'} onSubmit={handleSubmit(onSubmit)} loading={formState.isSubmitting}>
                        <input
                            type={'hidden'}
                            name={'product'}
                            value={1}
                            ref={register({required: true})}
                        />
                        <Form.Field>
                            <label>Categoria</label>
                            <Select
                                name={'course_category_id'}
                                placeholder='Selecione uma Categoria'
                                options={categories}
                                selectOnBlur={false}
                                clearable
                                onChange={(e, {value}) => {
                                    setValue('course_category_id', value);
                                }}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Nome</label>
                            <input
                                name={'name'}
                                ref={register({required: true})}
                                autoFocus
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Descrição</label>
                            <textarea
                                name={'description'}
                                ref={register({required: true})}
                                rows={2}
                            />
                        </Form.Field>
                    </Form>
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Button basic content={'Cancelar'} onClick={onCancel}/>
                <Button
                    positive
                    content="Salvar"
                    form={'form'}
                />
            </Modal.Actions>
        </Modal>
    )
}